<template>
    <b-form-input
        v-model="zipCode"
        class="zip-code"
        type="number"
        :state="zipCodeIsValid && !hasServerErrors"
    />
</template>

<script>
import _ from "lodash";

export default {
    name: "ZipCodeSelector",

    props: {
        selectedZipCode: {
            type: String,
            required: true,
            default: "",
        },
        locationServerErrors: {
            type: String,
            required: false,
            default: "",
        },
    },

    data() {
        return {
            zipCode: "",
        };
    },

    computed: {
        zipCodeIsValid() {
            return !_.isEmpty(this.zipCode) && this.zipCode.length === 5;
        },
        hasServerErrors() {
            return !_.isEmpty(this.locationServerErrors);
        },
    },

    watch: {
        zipCode() {
            if (this.zipCodeIsValid) {
                this.updateZipCode();
            }
        },
        zipCodeIsValid() {
            this.$emit("zip-code-is-valid", this.zipCodeIsValid);
        },
    },

    created() {
        if (!_.isNil(this.selectedZipCode)) {
            this.zipCode = this.selectedZipCode;
        }
    },

    methods: {
        updateZipCode() {
            this.$emit("zip-code-changed", this.zipCode);
        },
    },
};
</script>

<style lang="scss" scoped>
.zip-code {
    max-width: 100px;
    color: #4a4a4a;
}
/* hiding arrows in number input */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
</style>
